import type { SurfaceKind } from "./Surface";

/** Background class of each surface, internal to ui: app code paints through Surface, PageContainer or Card. */
export const SURFACE_BACKGROUND: Record<SurfaceKind, string> = { page: "bg-page", card: "bg-card", game: "bg-game-paper", night: "bg-night-sky" };
